export enum OrderTypeEnum {
  VENDOR = 'vendor',
  RESTAURANT = 'restaurant'
}
